export abstract class AbstractMessageType {
	abstract readonly id: Symbol;
	abstract readonly name: string;
}

export abstract class AbstractMessage<T = any> {
	abstract readonly type: AbstractMessageType;
	data: T;

	abstract create(data?: T): AbstractMessage<T>;

	constructor(data?: any) {
		this.data = data;
	}
}
